// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3eQS7","header":"PatientBlock_header__1XyVw","label":"PatientBlock_label__3A55f","option":"PatientBlock_option__g8hb4"};